'use client';

import * as React from 'react';
import { usePathname } from 'next/navigation';
import { Web3Providers } from './Web3Providers';

export function AppProviders({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isMiniAppRoute = pathname?.startsWith('/i/farcaster/mini') ?? false;

  if (isMiniAppRoute) {
    return <>{children}</>;
  }

  return <Web3Providers>{children}</Web3Providers>;
}
